import { z } from 'zod';

export const CargoProblemStatusSchema = z.enum([
  'DRAFT',
  'NEW',
  'REJECTED',
  'IN_PROGRESS',
  'REVIEW',
  'NOT_RESOLVED',
  'PARTIALLY_RESOLVED',
  'RESOLVED',
]);
export type CargoProblemStatus = z.infer<typeof CargoProblemStatusSchema>;

export const CargoProblemTerminalOutcomeSchema = z.enum([
  'NOT_RESOLVED',
  'PARTIALLY_RESOLVED',
  'RESOLVED',
]);
export type CargoProblemTerminalOutcome = z.infer<typeof CargoProblemTerminalOutcomeSchema>;

export function isCargoProblemTerminalOutcome(
  status: CargoProblemStatus,
): status is CargoProblemTerminalOutcome {
  return CargoProblemTerminalOutcomeSchema.safeParse(status).success;
}
